import React from 'react';
import { IoSquare, IoCheckbox, IoSquareOutline } from '../../../node_modules/react-icons/io5/index.esm.js';
import { genericMemo } from '../../../utils/index.js';

function Checkmark(props) {
  const {
    className,
    indeterminate,
    value
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, indeterminate && /*#__PURE__*/React.createElement(IoSquare, {
    className: className
  }), value && !indeterminate && /*#__PURE__*/React.createElement(IoCheckbox, {
    className: className
  }), !value && !indeterminate && /*#__PURE__*/React.createElement(IoSquareOutline, {
    className: className
  }));
}

var DefaultCheckmark = genericMemo(Checkmark);

export { DefaultCheckmark as default };
//# sourceMappingURL=index.js.map
